import { useEffect } from 'react'

const ADSENSE_CLIENT = 'ca-pub-7844927329398024'
const ADSENSE_SLOT = '9927209251'
const ADSENSE_SRC = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`

export default function AdBanner({ label }) {
  useEffect(() => {
    if (!document.querySelector(`script[src="${ADSENSE_SRC}"]`)) {
      const script = document.createElement('script')
      script.async = true
      script.crossOrigin = 'anonymous'
      script.src = ADSENSE_SRC
      document.head.appendChild(script)
    }

    window.adsbygoogle = window.adsbygoogle || []
    window.adsbygoogle.push({})
  }, [])

  return (
    <aside className="ad-section" aria-label={label}>
      <p>{label}</p>
      <ins
        className="adsbygoogle"
        style={{ display: 'block', minHeight: '280px' }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={ADSENSE_SLOT}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </aside>
  )
}
